import aygLogo from "@assets/images/AVATAR_AyG_1-100.jpg";
import oneX2Avatar from "@assets/images/AVATAR_PROVEEDORES/1x2_logo.jpg";
import threeOaksAvatar from "@assets/images/AVATAR_PROVEEDORES/3 oaks.jpg";
import sevenMojosAvatar from "@assets/images/AVATAR_PROVEEDORES/7_mojos_logo.jpg";
import sevenGamingAvatar from "@assets/images/AVATAR_PROVEEDORES/7777 gaming logo.png";
import apolloAvatar from "@assets/images/AVATAR_PROVEEDORES/apollo_games_logo.jpg";
import avataruxAvatar from "@assets/images/AVATAR_PROVEEDORES/avatarux_logo.jpg";
import aviatrixAvatar from "@assets/images/AVATAR_PROVEEDORES/aviatrix_logo.jpg";
import betbyAvatar from "@assets/images/AVATAR_PROVEEDORES/BETBY_AVATAR.jpg";
import bgamingAvatar from "@assets/images/AVATAR_PROVEEDORES/BGAMING_AVATAR.jpg";
import betgamesAvatar from "@assets/images/AVATAR_PROVEEDORES/betgames_logo.jpg";
import bigtimegamingAvatar from "@assets/images/AVATAR_PROVEEDORES/bigtimegaming_logo.jpg";
import boldplayAvatar from "@assets/images/AVATAR_PROVEEDORES/boldplay_logo.jpg";
import caletaAvatar from "@assets/images/AVATAR_PROVEEDORES/caleta_gaming_logo.jpg";
import ctinteractiveAvatar from "@assets/images/AVATAR_PROVEEDORES/ct_intereactive_logo.jpg";
import endorphinaAvatar from "@assets/images/AVATAR_PROVEEDORES/ENDORPHINA_AVATAR.jpg";
import evolutionAvatar from "@assets/images/AVATAR_PROVEEDORES/EVOLUTION_AVATAR.jpg";
import evoplayAvatar from "@assets/images/AVATAR_PROVEEDORES/EVOPLAY_AVATAR.jpg";
import faziAvatar from "@assets/images/AVATAR_PROVEEDORES/fazi_games_logo.jpg";
import fugasoAvatar from "@assets/images/AVATAR_PROVEEDORES/fugaso_logo.jpg";
import funkygamesAvatar from "@assets/images/AVATAR_PROVEEDORES/funkygames_logo.jpg";
import gameartAvatar from "@assets/images/AVATAR_PROVEEDORES/gameart_logo.jpg";
import gamzixAvatar from "@assets/images/AVATAR_PROVEEDORES/gamzix_logo.jpg";
import greazygamesAvatar from "@assets/images/AVATAR_PROVEEDORES/grazgame_logo.jpg";
import hacksawAvatar from "@assets/images/AVATAR_PROVEEDORES/HACKSAW_AVATAR.jpg";
import hub88Avatar from "@assets/images/AVATAR_PROVEEDORES/Hub88_logo.jpg";
import habaneroAvatar from "@assets/images/AVATAR_PROVEEDORES/habanero_logo.jpg";
import iconic21Avatar from "@assets/images/AVATAR_PROVEEDORES/iconic21_logo.jpg";
import kagaAvatar from "@assets/images/AVATAR_PROVEEDORES/kaga_logo.jpg";
import kalambaAvatar from "@assets/images/AVATAR_PROVEEDORES/kalamba_logo.jpg";
import kironAvatar from "@assets/images/AVATAR_PROVEEDORES/kiron_logo.jpg";
import luckystreakAvatar from "@assets/images/AVATAR_PROVEEDORES/luckystreak_logo.jpg";
import mancalaAvatar from "@assets/images/AVATAR_PROVEEDORES/mancala_gaming_logo.jpg";
import mrslottyAvatar from "@assets/images/AVATAR_PROVEEDORES/mrslotty_logo.png";
import netentAvatar from "@assets/images/AVATAR_PROVEEDORES/netent_logo.jpg";
import netgameAvatar from "@assets/images/AVATAR_PROVEEDORES/netgame_logo.jpg";
import onetouchAvatar from "@assets/images/AVATAR_PROVEEDORES/onetouch_logo.jpg";
import pixmoveAvatar from "@assets/images/AVATAR_PROVEEDORES/PIXMOVE_AVATAR.jpg";
import platipusAvatar from "@assets/images/AVATAR_PROVEEDORES/Platipus_logo.jpg";
import pragmaticAvatar from "@assets/images/AVATAR_PROVEEDORES/PRAGMATIC_AVATAR.jpg";
import pgsoftAvatar from "@assets/images/AVATAR_PROVEEDORES/pg_soft_logo.jpg";
import playsonAvatar from "@assets/images/AVATAR_PROVEEDORES/playson_logo+.jpg";
import redtigerAvatar from "@assets/images/AVATAR_PROVEEDORES/redtiger_logo.jpg";
import rubyplayAvatar from "@assets/images/AVATAR_PROVEEDORES/ruby play_logo.jpg";
import salsaAvatar from "@assets/images/AVATAR_PROVEEDORES/salsa technology_logo.jpg";
import smartbetAvatar from "@assets/images/AVATAR_PROVEEDORES/smartbet_logo.jpg";
import smartsoftAvatar from "@assets/images/AVATAR_PROVEEDORES/smartsoft_logo.jpg";
import superlottoAvatar from "@assets/images/AVATAR_PROVEEDORES/super lotto_logo.jpg";
import tadaAvatar from "@assets/images/AVATAR_PROVEEDORES/TADA_AVATAR.jpg";
import thunderspinAvatar from "@assets/images/AVATAR_PROVEEDORES/thunderspin_logo.jpg";
import turbogamesAvatar from "@assets/images/AVATAR_PROVEEDORES/turbogames_logo.jpg";
import tvbetAvatar from "@assets/images/AVATAR_PROVEEDORES/tvbet_logo.png";
import upgamingAvatar from "@assets/images/AVATAR_PROVEEDORES/UPGAMING_AVATAR.jpg";
import vibraAvatar from "@assets/images/AVATAR_PROVEEDORES/vibra_logo.jpg";
import wazdanAvatar from "@assets/images/AVATAR_PROVEEDORES/wazdan_logo.jpg";
import gamingcorps from "@assets/images/providers-logos/gamingcorps.svg";

/** @typedef {"user" | "community" | "promotion" | "provider"} StoryType */

/**
 * @typedef {Object} Story
 * @property {string} id
 * @property {string} label
 * @property {string} icon - URL or import reference
 * @property {StoryType} type
 * @property {boolean} [viewed]
 * @property {string} [providerKey] - provider slug for provider-type stories
 * @property {string} [ringVariant] - CSS ring variant key
 */

/** @type {Record<string, string>} */
export const PROVIDER_LOGOS = {
  "1x2gaming": oneX2Avatar,
  "1x2": oneX2Avatar,
  "3oaks": threeOaksAvatar,
  "3oaksgaming": threeOaksAvatar,
  "7777gaming": sevenGamingAvatar,
  7777: sevenGamingAvatar,
  "7mojos": sevenMojosAvatar,
  apollogames: apolloAvatar,
  apolloplay: apolloAvatar,
  apollo: apolloAvatar,
  avatarux: avataruxAvatar,
  aviatrix: aviatrixAvatar,
  betby: betbyAvatar,
  betgames: betgamesAvatar,
  bgaming: bgamingAvatar,
  bigtimegaming: bigtimegamingAvatar,
  btg: bigtimegamingAvatar,
  boldplay: boldplayAvatar,
  caleta: caletaAvatar,
  caletagaming: caletaAvatar,
  ctinteractive: ctinteractiveAvatar,
  ct: ctinteractiveAvatar,
  endorphina: endorphinaAvatar,
  evolution: evolutionAvatar,
  evoplay: evoplayAvatar,
  fazi: faziAvatar,
  fugaso: fugasoAvatar,
  funkygames: funkygamesAvatar,
  gameart: gameartAvatar,
  gamingcorps,
  gamzix: gamzixAvatar,
  greazygames: greazygamesAvatar,
  grazgame: greazygamesAvatar,
  habanero: habaneroAvatar,
  hacksaw: hacksawAvatar,
  hub88: hub88Avatar,
  iconic21: iconic21Avatar,
  kagaming: kagaAvatar,
  kaga: kagaAvatar,
  kalamba: kalambaAvatar,
  kalambagames: kalambaAvatar,
  kiron: kironAvatar,
  luckystreak: luckystreakAvatar,
  mancala: mancalaAvatar,
  mancalagaming: mancalaAvatar,
  mrslotty: mrslottyAvatar,
  netent: netentAvatar,
  netgame: netgameAvatar,
  onetouch: onetouchAvatar,
  pgsoft: pgsoftAvatar,
  pixmove: pixmoveAvatar,
  platipus: platipusAvatar,
  playson: playsonAvatar,
  pragmatic: pragmaticAvatar,
  redtiger: redtigerAvatar,
  rubyplay: rubyplayAvatar,
  salsa: salsaAvatar,
  salsatechnology: salsaAvatar,
  smartbet: smartbetAvatar,
  smartsoft: smartsoftAvatar,
  superlotto: superlottoAvatar,
  tada: tadaAvatar,
  tadagaming: tadaAvatar,
  thunderspin: thunderspinAvatar,
  turbogames: turbogamesAvatar,
  tvbet: tvbetAvatar,
  upgaming: upgamingAvatar,
  vibra: vibraAvatar,
  wazdan: wazdanAvatar,
};

/**
 * Resolves a provider logo from PROVIDER_LOGOS, normalizing aggregator suffixes
 * like "__upgaming", spaces, underscores, and hyphens.
 * @param {string} rawKey - The provider name as returned by the API
 * @returns {string | undefined} The resolved logo import, or undefined
 */
export const getProviderLogo = rawKey => {
  if (!rawKey) return undefined;
  const lower = rawKey.toLowerCase();
  if (PROVIDER_LOGOS[lower]) return PROVIDER_LOGOS[lower];
  const base = lower.split("__")[0].replace(/[\s_-]+/g, "");
  if (PROVIDER_LOGOS[base]) return PROVIDER_LOGOS[base];
  const withoutAggregator = base.replace(/(upgaming|hub88)$/, "");
  return PROVIDER_LOGOS[withoutAggregator];
};

/** @type {Story[]} */
export const AYG_PROMO_STORIES = [
  {
    id: "ayg",
    label: "AYG",
    icon: aygLogo,
    type: "promotion",
    ringVariant: "promotion",
  },
  {
    id: "promo",
    label: "Promo",
    icon: "https://placehold.co/360x640/1a1a2e/e040fb?text=PROMO",
    type: "promotion",
    ringVariant: "promotion",
  },
  {
    id: "torneo",
    label: "Torneo",
    icon: "https://placehold.co/360x640/1a1a2e/3b82f6?text=TORNEO",
    type: "promotion",
    ringVariant: "promotion",
  },
  {
    id: "testimonio",
    label: "Testimonio",
    icon: "https://placehold.co/360x640/1a1a2e/ff6b6b?text=TESTIMONIO",
    type: "promotion",
    ringVariant: "promotion",
  },
  {
    id: "giros-gratis",
    label: "Giros Gratis",
    icon: "https://placehold.co/360x640/1a1a2e/4ade80?text=GIROS+GRATIS",
    type: "promotion",
    ringVariant: "promotion",
  },
];

/** Promotion stories only visible to authenticated users */
/** @type {Story[]} */
export const AUTH_ONLY_STORIES = [
  {
    id: "cashback-13",
    label: "Cashback 13%",
    icon: "https://placehold.co/360x640/1a1a2e/ff9900?text=CASHBACK%0A13%25%0ATOTAL",
    type: "promotion",
    ringVariant: "promotion",
  },
  {
    id: "torneo-vip",
    label: "Torneo VIP",
    icon: "https://placehold.co/360x640/1a1a2e/a855f7?text=TORNEO+VIP",
    type: "promotion",
    ringVariant: "promotion",
  },
];

export const STORY_DURATION = 5000;
export const GUEST_MAX_STORIES = 3;
